import axiosInstance from '../axiosInstance';

const getEventSectionsLeaderboard = async (eventId) => {
  return axiosInstance.get(`/leaderboard/event/${eventId}/sectionleaderboard`).then((response) => {
    return response.data;
  });
};

const getSectionLog = async (eventId, sectionId) => {
  return axiosInstance
    .get(`/leaderboard/event/${eventId}/section/${sectionId}/log`)
    .then((response) => {
      return response.data;
    });
};

const getEventLeaderboard = async (eventId) => {
  return axiosInstance.get(`/leaderboard/event/${eventId}/leaderboard`).then((response) => {
    return response.data;
  });
};

const getEventScorecard = async (eventId) => {
  return axiosInstance.get(`/leaderboard/event/${eventId}/scorecard`).then((response) => {
    return response.data;
  });
};

const getEndingPositions = async (eventId, data) => {
  return axiosInstance
    .post(`/leaderboard/event/${eventId}/ending-positions`, data)
    .then((response) => {
      return response.data;
    });
};

const leaderboardService = {
  getEventSectionsLeaderboard,
  getEventLeaderboard,
  getEventScorecard,
  getSectionLog,
  getEndingPositions
};

export default leaderboardService;
